import storeModules from "@/match/store/storeModules";

const store = new window.Vuex.Store({
  modules: {
    ...storeModules,
    index: storeModules.index,
    navHeader: require('./navHeader').default
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/wenxing/store/index.js